import { useEffect, useRef, useState } from "react";
import { Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { fmtDate } from "@/lib/api";

export const ChatThread = ({ messages, onSend, meRole, emptyText }) => {
  const [text, setText] = useState("");
  const [sending, setSending] = useState(false);
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: "smooth" }); }, [messages?.length]);

  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSending(true);
    await onSend(text.trim());
    setText("");
    setSending(false);
  };

  return (
    <div className="flex h-[60vh] min-h-[420px] flex-col rounded-md border border-stone-200 bg-white">
      <div className="flex-1 space-y-4 overflow-y-auto p-6" data-testid="chat-messages">
        {(messages || []).length === 0 && <p className="py-16 text-center text-sm text-stone-500">{emptyText}</p>}
        {(messages || []).map((m) => {
          const mine = m.sender_role === meRole;
          return (
            <div key={m.id} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid="chat-message">
              <div className={`max-w-[80%] rounded-lg px-4 py-3 ${mine ? "bg-slate-900 text-white" : "bg-stone-100 text-stone-900"}`}>
                <p className="whitespace-pre-wrap text-sm">{m.body}</p>
                <p className={`mt-1.5 text-[10px] font-mono uppercase tracking-wider ${mine ? "text-stone-400" : "text-stone-500"}`}>
                  {m.sender_role === "admin" ? "Recruitment team" : m.sender_name} · {fmtDate(m.created_at)}
                </p>
              </div>
            </div>
          );
        })}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="flex gap-2 border-t border-stone-200 p-4">
        <Textarea
          data-testid="chat-input"
          value={text}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) send(e); }}
          placeholder="Write a message…"
          rows={2}
          className="resize-none"
        />
        <Button type="submit" disabled={sending || !text.trim()} data-testid="chat-send-button" className="h-auto px-5">
          <Send className="h-4 w-4" />
        </Button>
      </form>
    </div>
  );
};
